class Merger {
  mergeObjectsImmutable(objectA, objectB) {
    return Object.assign({}, objectA, objectB);
  }
}
const merger = new Merger();
export default merger;